<template>
	<div class="resp-flex">

		<nav class="navbar navbar-expand-lg navbar-light " v-if="me">
			<div class="container-fluid">
				<template v-if="this.logo">
					<div class="navbar-brand login_logo_wrapper">
					</div>
				</template>
				<button class="navbar-toggler" type="button" @click.prevent="toggleHideDropdown()"
								aria-controls="#navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<div :class="'collapse navbar-collapse ' + toggleHideDropdownName" id="navbarSupportedContent">
					<ul class="navbar-nav me-auto mb-2 mb-lg-0">
						<li class="nav-item">
							<router-link class="nav-link" to="/">მონიტორინგი</router-link>
						</li>
						<li v-if="showReportsTab" class="nav-item">
							<router-link class="nav-link" to="/reports">რეპორტები</router-link>
						</li>

						<li v-if="showUsersTab" class="nav-item">
							<div class="red-circle small-circle"
									 v-if="this.isUnreadAlert && parseInt(this.isUnreadAlert.data) > 0"></div>
							<router-link class="nav-link" to="/received-alerts">
								განგაშები
							</router-link>
						</li>
						<li class="nav-item">
							<router-link class="nav-link " to="/settings">პარამეტრები</router-link>
						</li>
					</ul>

					<div class="d-none d-md-block d-flex align-content-end justify-content-end toolbar-area">
						<OnClickOutside @trigger="closeDropdown">
							<ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center justify-content-center position-relative">

								<li class="nav-item nav-with-icon d-flex" @click="toggleAlertDropdown">
									<img src="/svgs/profile-circle.svg" title="მოხმმარებელი">
									{{ me.nickname }}
								</li>
								<div class="profile-dropdown" v-if="this.isShowingProfileDropdown && me">
									<div class="profile-content">
										<ul>
											<li class="no-hover">
												<div class="d-flex justify-content-start align-items-start">
													<img src="/svgs/user-profile.svg" alt="">
													<p class="text second-title">
														<span class="label-color">{{ me.firma.name }}</span><br/>
														აბონენტი: 0{{ me.firma.id }}
													</p>
												</div>
											</li>
											<!--                  <li class="border-top">-->
											<!--                    <img src="/svgs/billing.svg" alt="">-->
											<!--                    ბილინგი-->
											<!--                  </li>-->
											<!--                  <li>-->
											<!--                    <img src="/svgs/instruction.svg" alt="">-->
											<!--                    ინსტრუქცია-->
											<!--                  </li>-->
											<li class="border-top font-roboto">
												<img src="/svgs/envelope.svg" alt="">
												info@casatrade.ge
											</li>
											<li class="font-roboto">
												<img src="/svgs/call.svg" alt="">
												(+995) 32 555 999
											</li>
											<li v-if="me.firma.id == 1618" class="font-roboto">
                        <div @click="toggleFakeData" class="d-flex gap-2">
                          <input :checked="fakeData" type="checkbox" id="filter" value="" class="form-check-input ms-1 me-2">
                          <label class="form-check-label" for="filter">ფილტრი</label>
                        </div>
											</li>
											<li class="border-top" @click="logOut">
												<img src="/svgs/logout.svg" alt="">
												გასვლა
											</li>
										</ul>
									</div>
								</div>
								<!--            <li class="nav-item d-flex last-nav-item ">-->
								<!--              <a class="nav-link nav-with-icon" aria-current="page" href="#" @click="logOut">-->
								<!--                <img src="/svgs/log-out.svg"  title="გამოსვლა">-->
								<!--              </a>-->
								<!--            </li>-->
							</ul>
						</OnClickOutside>
					</div>
				</div>
			</div>
		</nav>
		<div class="d-none responsive-profile-bar d-flex align-content-end justify-content-end toolbar-area" v-if="me">
			<OnClickOutside @trigger="closeDropdown">
				<ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center justify-content-center position-relative">

					<li class="nav-item nav-with-icon d-flex" @click="toggleAlertDropdown">
						<img src="/svgs/profile-circle.svg" title="მოხმმარებელი">
						{{ me.nickname }}
					</li>
					<div class="profile-dropdown" v-if="this.isShowingProfileDropdown && me">
						<div class="profile-content">
							<ul>
								<li class="no-hover">
									<div class="d-flex justify-content-start align-items-start">
										<img src="/svgs/user-profile.svg" alt="">
										<p class="text second-title">
											<span class="label-color">{{ me.firma.name }}</span><br/>
											აბონენტი: 0{{ me.firma.id }}
										</p>
									</div>
								</li>
								<!--                  <li class="border-top">-->
								<!--                    <img src="/svgs/billing.svg" alt="">-->
								<!--                    ბილინგი-->
								<!--                  </li>-->
								<!--                  <li>-->
								<!--                    <img src="/svgs/instruction.svg" alt="">-->
								<!--                    ინსტრუქცია-->
								<!--                  </li>-->
								<li class="border-top font-roboto">
									<img src="/svgs/envelope.svg" alt="">
									info@casatrade.ge
								</li>
								<li class="font-roboto">
									<img src="/svgs/call.svg" alt="">
									(+995) 32 555 999
								</li>
								<li class="border-top" @click="logOut">
									<img src="/svgs/logout.svg" alt="">
									გასვლა
								</li>
							</ul>
						</div>
					</div>
					<!--            <li class="nav-item d-flex last-nav-item ">-->
					<!--              <a class="nav-link nav-with-icon" aria-current="page" href="#" @click="logOut">-->
					<!--                <img src="/svgs/log-out.svg"  title="გამოსვლა">-->
					<!--              </a>-->
					<!--            </li>-->
				</ul>
			</OnClickOutside>
		</div>

	</div>


</template>

<script>

import {OnClickOutside} from "@vueuse/components";

export default {
	name: 'NavItem',
	components: {OnClickOutside},
	computed: {
		isUnreadAlert() {
			return this.$store.state.alert.alertCount
		},
		showingLastAlertIcon() {
			return this.$store.state.alert.showingLastAlertIcon
		},
		lastAlert() {
			return this.$store.state.alert.lastAlert
		},
		warehouses() {
			return this.$store.state.warehouse.list.data
		},
		me() {
			if (this.$store.state.user.me) {
				return this.$store.state.user.me.data
			}
			return null;
		},
		showUsersTab() {
			if (!this.me) {
				return false;
			}
			return this.me.rolleid === 0 || (this.me.permissions && this.me.permissions[1] && this.me.permissions[1].read);
		},
		showAlertsTab() {
			if (!this.me) {
				return false;
			}
			return this.me.rolleid === 0 || (this.me.permissions && this.me.permissions[2] && this.me.permissions[2].read);
		},
		showReportsTab() {
			if (!this.me) {
				return false;
			}
			return this.me.rolleid === 0 || (this.me.permissions && this.me.permissions[3] && this.me.permissions[3].read);
		},
    fakeData() {
      return this.$store.state.user.fakeData
    }
	},
	methods: {
		toggleHideDropdown() {
			this.toggleHideDropdownName = this.toggleHideDropdownName === '' ? 'opened-dropdown' : ''
		},
		toggleAlertDropdown() {
			this.isShowingProfileDropdown = !this.isShowingProfileDropdown
		},
		closeDropdown() {
			this.isShowingProfileDropdown = false
		},
		iconProfile() {
			if (this.$route.fullPath === '/settings') {
				this.profileIcon = '/svgs/setting-2.svg'
			} else {
				this.profileIcon = '/svgs/cog.svg'
			}
			return this.profileIcon
		},
		getAlertIcon() {
			if (this.$route.fullPath === '/received-alerts') {
				this.alertIcon = '/svgs/alert-active.svg'
			} else {
				this.alertIcon = '/svgs/alert.svg'
			}
			return this.alertIcon
		},
		logOut() {
			this.$store.dispatch('auth/logout')
			document.location = '/login'

			// this.$router.push('/login')
		},
    toggleFakeData() {
      this.$store.dispatch('user/toggleFakeData').then(() => {
        this.$store.dispatch('warehouse/getWarehouseList', true)
        this.$store.dispatch('warehouse/getAllLastTransmissions')
      })
    }
	},
	props: ['logo'],
	data() {
		return {
			isShowingProfileDropdown: false,
			alertOpened: false,
			alertIcon: 'alert.svg',
			currentPage: 0,
			profileIcon: '/svgs/cog.svg',
			toggleHideDropdownName: ''
		}
	},
	mounted() {
		this.$store.dispatch('user/me').then(
				() => {
					this.loading = false
				}
		)
		this.$store.dispatch('alert/unreadedAlertcount')
    this.$store.dispatch('user/getFakeDataEnabled')

	}
}
</script>

<style scoped>

.alert-wrapper {
	position: relative;
}

.alert-counter {
	position: absolute;
	right: 5px;
	top: 5px;
	background-color: var(--alert-red-color);
	font-size: 14px;
	color: #ffffff;
	border-radius: 100px;
	width: 20px;
	height: 20px;
	padding-left: 2px;
	padding-right: 2px;
}

.toolbar-area {
	position: relative;
}

.toolbar-area ul li:hover {
	cursor: pointer;
}

.alert-dropdown {
	color: var(--second-titles);
	text-align: left;
	position: absolute;
	top: 80%;
	right: 0;
	padding: 20px;
	z-index: 9999;
	border-radius: 5px;
	font-size: 16px;
	font-family: "TBCDinNusxuri-Medium";
}

.alert-dropdown .alert-content {
	background: #FFFFFF;
	-webkit-box-shadow: 0 16px 40px #708CB0;
	box-shadow: 0 16px 40px #708CB0;
	width: 100%;
	color: var(--text-sub-bold-color);

}

.alert-dropdown .scrollable {
	height: 80vh;
	overflow-y: auto;
	padding-right: 15px;
}

.alert-dropdown ul {
	list-style-type: none;
	padding: 20px 0;
	width: 270px;
}

.alert-dropdown ul li {
	padding: 15px 0;
	/*padding-right: 20px;*/
}

.alert-dropdown ul li:hover {
	background: var(--hover-item);
	border-radius: 5px;
	cursor: pointer;
}

.alert-dropdown ul li:not(:last-child) {
	border-bottom: 1px solid var(--border-color);
}

nav {
	font-family: "TBCDinMtavruli-Bold";
	font-size: 18px;
}

.nav-link {
	color: var(--nav-text-color) !important;
}

.nav-link.active {
	color: var(--main-bg) !important;
}

.nav-with-icon {
	color: var(--nav-text-color);
}

.nav-with-icon img {
	padding-right: 5px;
	width: 30px;
}

.nav-item {
	position: relative;
}

.last-nav-item {
	padding-left: 30px;
}

.profile-dropdown {
	position: absolute;
	background: #FFFFFF;
	width: 230px;
	margin-top: 25%;
	top: 100%;
	right: 0;
	border-radius: 5px;
	-webkit-box-shadow: 0 0 30px rgba(112, 140, 176, 0.21);
	box-shadow: 0 0 30px rgba(112, 140, 176, 0.21);
	z-index: 99999;
}

.profile-dropdown:before {
	content: "";
	display: block;
	position: absolute;
	right: 1rem;
	top: -15px;
	border-bottom: 15px solid #FFFFFF;
	border-left: 15px solid transparent;
	border-right: 15px solid transparent;

}


.profile-content {
	width: 100%;
}

.profile-content ul {
	list-style-type: none;
	padding-left: 0;
	padding-right: 0;
	padding-top: 5px;
	padding-bottom: 5px;
}

.profile-content ul li:first-child {
	padding-bottom: 0;
}

.profile-content ul li {
	padding: 5px;
	padding-left: 15px;
	padding-right: 15px;
	text-align: left;
	font-size: 14px;
	font-family: "TBCDinNusxuri-Medium";
}

.profile-content ul li img {
	margin-right: 10px;
}

.profile-content ul li:hover:not(.no-hover) {
	background: var(--hover-item);
	cursor: pointer;
}


.profile-content ul li.border-top {
	border-top: 1px solid var(--border-color);
}

p {
	font-family: "TBCDinNusxuri-Medium";
}

p.title {
	font-size: 16px;
}

p.text {
	font-size: 14px;
	margin-bottom: 5px;
}

.small-circle {
	width: 8px !important;
	height: 8px !important;
	padding: 0;
	position: absolute;
	top: 4px;
	left: 81%;
}

@media only screen and (min-width: 1198px) and (max-width: 1679px) {
	nav {
		font-size: 16px;
	}
}
</style>